import React, { useEffect, useRef } from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import classNames from 'classnames';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Cta from '../components/sections/Cta';
import { useLocation, Switch } from 'react-router-dom';
import styled from 'styled-components';
// import ScrollReveal from '../utils/ScrollReveal';

import '../assets/scss/style.scss';
import Pricing from '../components/sections/Pricing';
import { scrollToSection } from '../utils/navigationUtils';

const Privacy = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {
    const childRef = useRef();
    const location = useLocation();

    useEffect(() => {
        if (!location.hash.startsWith('#')) return undefined;

        const sectionId = decodeURIComponent(location.hash.substring(1));
        const timer = setTimeout(() => scrollToSection(sectionId, 96), 100);
        return () => clearTimeout(timer);
    }, [location.hash]);

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
        title: 'Privacy policy'
        // paragraph: "Modularity and functionality. That's what we love the most."
    };

    return (
        <CustomStyle>
            <Header navPosition="right" className="reveal-from-bottom" />
            <main className="site-content">
                <section {...props} className={outerClasses}>
                    <div className="container-sm">
                        <div className={innerClasses} style={{ textAlign: 'left' }}>
                            <SectionHeader data={sectionHeader} className="center-content" tag="h1" />
                            {/* <p className="m-0 text-sm mb-16"><em>Last Updated: November 21, 2021</em></p> */}
                            <p className="m-0 text-sm">
                                Your privacy is important to us, and we are committed to being transparent about how we collect, use, and protect your information. We store as little data as possible to create a great experience, and we will never store data that we don't use. This policy is intended to help you understand:
                            </p>
                            <ul className="mt-12" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm">What information we collect from you</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">What we do with your information</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">How long we keep information</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">Our payment services</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">Third-party services we use</p>
                                </li>
                            </ul>
                            <p className="m-0 text-sm mt-16">
                                <strong>Your data is yours, not ours.</strong> Delete anything (or everything) whenever you'd like. We will never sell your data. Data collection and/or sale is not the kind of business we're in.
                            </p>

                            <h4 className="mt-32 mb-8">Information Gathering and Usage</h4>
                            <p className="m-0 text-sm">
                                When you create a Luckynote account to sync your notes across devices, we ask for basic account information like an email address and password. Your notes are stored on a central server, allowing them to be synced on your other devices. Subscribing to Luckynote Pro requires billing information, but we only use your information internally and will not share it with others.
                                {/* Luckynote collects aggregated, anynomous
                                user data regarding app usage. The user data we collect is used to enhance the quality
                                of our service and product. Luckynote also automatically collects crash log so that we
                                can improve the product reliability. The information in the crash log may include your
                                device information, stack trace, your IP address and other data that can be helpful to
                            debug the issue. */}
                            </p>
                            <h4 className="mt-32 mb-8">Types of Data Collected</h4>
                            <h6 className="m-0 mb-16">Personal Data</h6>
                            <p className="m-0 text-sm mb-16">While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:</p>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm">Email address</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">Name (if provided)</p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm">Cookies and Usage Data</p>
                                </li>
                            </ul>
                            <p className="m-0 text-sm mb-16">We may use your Personal Data to contact you through newsletters, marketing materials, or promotional materials, as well as other communication that may interest you. Opting out of these communications can be done by following the unsubscribe link or instructions provided in any sent email, or by contacting us.</p>
                            <h6 className="m-0 mb-16">Usage Data</h6>
                            <p className="m-0 text-sm mb-16">We may collect Usage Data, including information related to how our Service is accessed and used. This data can include your computer's Internet Protocol address (IP address), browser type and version, visited pages of our Service, date and time of your visit, time spent on these pages, unique device identifiers, and diagnostic data.</p>
                            <h6 className="m-0 mb-16" id="tracking-cookies">Tracking & Cookies Data</h6>
                            <p className="m-0 text-sm mb-16">Our public site uses Umami, a privacy-focused, cookie-free analytics service, to understand aggregate visits, referrers, and which public pages are read. We do not use Google Analytics, Meta Pixel, or advertising cookies on the public site.</p>
                            <p className="m-0 text-sm mb-16">Our authentication system uses browser localStorage (not cookies) to store login tokens on your device. Signed-in product analytics are handled separately through Mixpanel to help us understand which features are useful.</p>


                            <h4 className="mt-32 mb-8" id="your-information-is-protected">Your Information is Protected</h4>
                            <p className="m-0 text-sm">
                                We are fully committed to protecting your privacy. Everything you send to and from Luckynote travels over a secure, encrypted connection, and your notes, files, and account data are stored securely and encrypted. For a full plain-language breakdown, see our <a href="/data-security" style={{ color: '#2b88d9' }}>Data Security</a> page.
                            </p>
                            <p className="m-0 text-sm mt-16">
                                We use Amazon Web Services (AWS), Cloudinary, and Bunny.net as data storage and CDN partners. All data is encrypted at-rest in storage and in-transit to and from storage. These services are certified under significant privacy and security standards, such as the EU General Data Protection Regulation (GDPR). Learn more at {' '}
                                <a href="https://aws.amazon.com/privacy/" style={{ color: '#2b88d9' }}>
                                    https://aws.amazon.com/privacy/
                                </a>
                                {', '}
                                <a href="https://cloudinary.com/privacy" style={{ color: '#2b88d9' }}>
                                    https://cloudinary.com/privacy
                                </a>
                                {', and '}
                                <a href="https://bunny.net/privacy" style={{ color: '#2b88d9' }}>
                                    https://bunny.net/privacy
                                </a>
                                .
                            </p>
                            <h4 className="mt-32 mb-8">How Long We Keep Information</h4>
                            <p className="m-0 text-sm">
                                Your information remains with Luckynote while you use our service. To delete content, move your notes to the trash, then empty it. This will eliminate the data on the server and any devices you've logged into. You can delete your account at any time through your account settings. Upon deletion, your account data will be removed from our systems within 30 days, after which point it will be entirely unrecoverable. Please note this process is irreversible.
                            </p>
                            <h4 className="mt-32 mb-8">Data Portability</h4>
                            <p className="m-0 text-sm">
                                In Luckynote, you can download individual files and images to use elsewhere, and you can also export your entire account (folders, notes, highlights, and saved links) from Settings at any time. We'll package it up and email you a download link. Our principle is simple: your data is yours, and we have no interest in getting in the way of that.
                            </p>
                            <h4 className="mt-32 mb-8">3rd Party Partners</h4>
                            <p className="m-0 text-sm mb-16">We work with the following third-party services to provide and improve our Service:</p>
                            
                            <h6 className="m-0 mb-8 mt-16">AI Services</h6>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm"><strong>OpenRouter</strong> - We use OpenRouter to provide access to AI models (Claude, Google AI, OpenAI, xAI, etc.) for chat completions, text analysis, and content generation. This data is anonymized and is never used for model training. <a href="https://openrouter.ai/privacy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>OpenAI</strong> - We use OpenAI models (via OpenRouter or directly) to expand responses and encode user requests. This data is anonymized and is never used for model training. <a href="https://openai.com/privacy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>Groq</strong> - We use Groq for fast speech-to-text transcription. <a href="https://groq.com/privacy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                            </ul>

                            <h6 className="m-0 mb-8 mt-16">Data Storage & CDN</h6>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm"><strong>AWS</strong> - We use AWS as a data storage partner, and all data is encrypted at-rest in storage and in-transit to and from storage. AWS also handles our authentication (login, logout, signup), and so securely stores email addresses and user names to support that. <a href="https://aws.amazon.com/privacy/" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>Cloudinary</strong> - We use Cloudinary for image processing and storage. All data is encrypted at-rest and in-transit. <a href="https://cloudinary.com/privacy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>Bunny</strong> - We use Bunny as a secure CDN to serve images at different resolutions to users that have access to see them. For example, if you save an image to Luckynote, we use Bunny to be able to serve it to you at multiple sizes on any device with minimal latency. <a href="https://bunny.net/privacy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                            </ul>

                            <h6 className="m-0 mb-8 mt-16">Email Services</h6>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm"><strong>Resend</strong> - We use Resend to deliver all emails from Luckynote, including account emails (such as password resets and verification), welcome emails, and product updates. You can unsubscribe from marketing and product update emails at any time. <a href="https://resend.com/legal/privacy-policy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                            </ul>

                            <h6 className="m-0 mb-8 mt-16">Analytics</h6>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm"><strong>Mixpanel</strong> - We use Mixpanel to track the anonymized performance of features inside the product, to understand what is useful and what isn't in an aggregate sense. For example, "a new note was created 12,000 times this week". <a href="https://mixpanel.com/legal/privacy-policy/" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>Umami</strong> - We use Umami, a privacy-focused analytics tool, to understand traffic and usage on our website without relying on invasive tracking. <a href="https://umami.is/privacy-policy" style={{ color: '#2b88d9' }}>Learn more</a></p>
                                </li>
                            </ul>

                            <h4 className="mt-32 mb-8">Payments</h4>
                            <p className="m-0 text-sm mb-16">We may offer paid products and/or services within our Service. In these cases, third-party services handle payment processing (e.g., payment processors).</p>
                            <p className="m-0 text-sm mb-16">We don't store or collect your payment card details; this information is provided directly to third-party payment processors, whose use of your personal information is governed by their Privacy Policy. These processors adhere to PCI-DSS standards managed by the PCI Security Standards Council, a collaboration between brands like Visa, Mastercard, American Express, and Discover. PCI-DSS requirements ensure the secure handling of payment information.</p>
                            <p className="m-0 text-sm mb-16">Our payment processors:</p>
                            <ul className="mt-12 mb-16" style={{ listStyle: 'initial', paddingLeft: 40 }}>
                                <li>
                                    <p className="m-0 text-sm"><strong>Stripe</strong> - We use Stripe for web-based payment processing. Their Privacy Policy can be viewed at <a href='https://stripe.com/us/privacy' style={{ color: '#2b88d9' }}>https://stripe.com/us/privacy</a></p>
                                </li>
                                <li>
                                    <p className="m-0 text-sm"><strong>RevenueCat</strong> - We use RevenueCat for mobile app (iOS and Android) subscription management and payment processing. RevenueCat securely handles in-app purchases and subscription management. Their Privacy Policy can be viewed at <a href='https://www.revenuecat.com/privacy' style={{ color: '#2b88d9' }}>https://www.revenuecat.com/privacy</a></p>
                                </li>
                            </ul>



                            <h4 className="mt-32 mb-8">Changes To This Privacy Policy</h4>
                            <p className="m-0 text-sm mb-16">We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                            <p className="m-0 text-sm mb-16">You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

                        </div>
                        <div style={{ height: 80 }} />
                    </div>
                </section>
            </main>
            <Footer />
        </CustomStyle>
    );
};

const CustomStyle = styled.div`
    body {
        font-size: 1rem;
    }
    // color: #9ca9b3;
    a {
        // font-weight: 400 !important;
        // text-decoration: none;
        //     &:not(.button) {
        //         color: #9ca9b3;
        //     }
        //     &.button-link {
        //         color: #9ca9b3;
        //     }

        //     &.func-link {
        //         color: #9ca9b3;
        //     }
        //     &:hover {
        //         color: #eceded;
        //     }
    }
    // h2,
    // .h2 {
    //     font-size: 44px !important;
    //     line-height: 54px !important;
    //     letter-spacing: -0.3px !important;
    // }
    // h3,
    // .h3 {
    //     font-weight: 700 !important;
    //     font-size: 32px !important;
    //     line-height: 42px !important;
    //     letter-spacing: -0.3px !important;
    // }
    // p {
    //     font-size: 1rem;
    //     line-height: 30px;
    // }
`;

export default Privacy;
